module.exports = __webpack_public_path__ + "img/lukaabrus.2774fc10.jpg";